import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  Alert,
  Snackbar,
  Box,
  LinearProgress,
  Backdrop,
  CircularProgress,
  CardMedia,
  Typography,
  Stack,
} from "@mui/material";
import { GlobalContext } from "./context/GlobalContext";
import PublicRoute from "./routing/PublicRoute";
import AdminRoute from "./routing/AdminRoute";
import UserRoute from "./routing/UserRoute";
import { TranslateContext } from "./context/TranslateContext";
import axios from "axios";
import FrontEnd from "./frontend/FrontEnd";
import LoginAdmin from "./admin/login/LoginAdmin";
import AdminDashboard from "./admin/dashboard/AdminDashboard";
import UserDashboard from "./user/dashboard/UserDashboard";
import UserLogin from "./user/login/UserLogin";
import Embed from "./embed/Embed";
import ViewPage from "./frontend/page/ViewPage";
import ContactForm from "./frontend/contactForm/ContactForm";
import CheckOut from "./frontend/checkout/CheckOut";

const HomeMainPage = () => {
  const GLOBAL_CONTEXT = React.useContext(GlobalContext);
  const LANGUAGE = React.useContext(TranslateContext);
  const [web, setWeb] = React.useState({});

  React.useEffect(() => {
    const code = localStorage.getItem("language");
    // const localcode = local.slice(0, local.indexOf('.'))
    if (code) {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/web/get-one-translation?code=${code}`
        )
        .then((res) => {
          if (res.data.notfound) {
            localStorage.removeItem("language");
            alert("Maybe translate file issue.");
            window.location.reload();
            return;
          }
          LANGUAGE.setData({ ...res.data.data });
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/web/get-all-translation-name`
        )
        .then((lan) => {
          localStorage.setItem(
            "language",
            lan.data.data[0]?.replace(".json", "")
          );
          axios
            .get(
              `${
                process.env.REACT_APP_BASE_URL
              }/api/web/get-one-translation?code=${lan.data.data[0]?.replace(
                ".json",
                ""
              )}`
            )
            .then((res) => {
              LANGUAGE.setData({ ...res.data.data });
            })
            .catch((err) => console.log(err));
        });
    }
  }, []);

  async function getWeb() {
    const res = await GLOBAL_CONTEXT.hitAxios({
      path: "/api/web/get_web_public",
      post: false,
      admin: false,
      token_user: "",
    });
    if (res.data.success) {
      setWeb(res.data.data);
    }
  }

  React.useEffect(() => {
    getWeb();
  }, []);

  return (
    <Box
      sx={{ position: "relative" }}
      color="text.primary"
      minHeight={"100vh"}
      bgcolor="background.default"
    >
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={GLOBAL_CONTEXT.data.snack}
        autoHideDuration={4000}
      >
        <Alert
          severity={GLOBAL_CONTEXT.data.snack_success ? "success" : "error"}
        >
          {GLOBAL_CONTEXT.data.snack_msg}
        </Alert>
      </Snackbar>

      <div
        style={{
          opacity:
            GLOBAL_CONTEXT.data.loading && GLOBAL_CONTEXT?.data?.globalLoad
              ? 0.25
              : 1,
          pointerEvents:
            GLOBAL_CONTEXT.data.loading && GLOBAL_CONTEXT?.data?.globalLoad
              ? "none"
              : "initial",
        }}
      >
        <Switch>
          <PublicRoute path="/" exact component={FrontEnd} />
          <PublicRoute path="/admin/login" exact component={LoginAdmin} />
          <AdminRoute path="/admin" exact component={AdminDashboard} />
          <UserRoute path="/user" exact component={UserDashboard} />
          <PublicRoute path="/user/login" exact component={UserLogin} />
          <PublicRoute path="/chat/embed" exact component={Embed} />
          <PublicRoute path="/view/:slug" exact component={ViewPage} />
          <PublicRoute
            path="/page/contact-form"
            exact
            component={ContactForm}
          />
          <UserRoute path="/user/checkout" exact component={CheckOut} />
        </Switch>
      </div>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 1400,
          backdropFilter: "blur(4px)",
        }}
        open={GLOBAL_CONTEXT.data.loading && GLOBAL_CONTEXT?.data?.globalLoad}
      >
        {
          <Stack direction={"column"} spacing={3} alignItems={"center"}>
            <Box className="gradient-border-animation">
              <CardMedia
                sx={{ height: 80, width: 80, cursor: "pointer" }}
                src={`/media/${web?.logo}`}
                component={"img"}
              />
            </Box>
            <CircularProgress color="inherit" size={20} />
          </Stack>
        }
      </Backdrop>
    </Box>
  );
};

export default HomeMainPage;
